module.exports = __webpack_public_path__ + "media/images/logo_p2-efe66522ce9fb50dc29f71c1abff01db.svg";